import { alpha } from '@monorepo/nova-ui';
import type { Components, Theme as MuiTheme } from '@mui/material';

// Extend the MUI theme to include our custom variant props
declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    'trading-option': true;
  }
}

declare module '@mui/material/Paper' {
  interface PaperPropsColorOverrides {
    selected: true;
    default: true;
  }
}

export const cardTheme: Components<MuiTheme> = {
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          padding: theme.spacing(0),
          borderRadius: theme.spacing(6),
          backgroundColor: theme.palette.background.contrast,
          border: '1px solid',
          borderColor: theme.palette.info.main,
          boxShadow: 'none',
        };
      },
    },
    variants: [
      {
        props: { variant: 'trading-option' },
        style: ({ theme }) => ({
          width: '100%',
          borderRadius: '24px',
          border: '1px solid',
          borderColor: theme.palette.info.main,
          boxShadow: 'none',
          height: '100%',
          transition: theme.transitions.create(
            ['background-color', 'box-shadow'],
            {
              duration: theme.transitions.duration.standard,
            },
          ),
          '&:hover': {
            border: 'none',
            backgroundColor: theme.palette.background.default,
            boxShadow: '-8px 8px 45px 20px  rgba(0, 0, 0, 0.15)',
          },
        }),
      },
      {
        props: { variant: 'trading-option', color: 'selected' },
        style: ({ theme }) => ({
          borderColor: theme.palette.info.main,
        }),
      },
      {
        props: { variant: 'trading-option', color: 'default' },
        style: ({ theme }) => ({
          borderColor: theme.palette.info.main,
          backgroundColor: theme.palette.background.contrast,
          '&:hover': {
            backgroundColor: alpha(theme.palette.white, 0.15),
            border: 'none',
          },
        }),
      },
    ],
  },
  MuiCardActionArea: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        if (ownerState.className?.includes('trading-option')) {
          return {
            gap: theme.spacing(2),
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            textAlign: 'left',
            padding: '20px',
            paddingTop: '32px',
            height: '100%',
            transition:
              'transform 0.2s ease-in-out background-color 0.2s ease-in-out',
            [theme.breakpoints.up('sm')]: {
              textAlign: 'center',
            },
            [theme.breakpoints.up('md')]: {
              flexDirection: 'column',
              alignItems: 'center',
              padding: '32px',
              paddingTop: '40px',
            },
            '& .MuiButtonBase-root': {
              width: 'fit-content',
              color: 'white',
              pointerEvents: 'none',
            },
            '&:disabled': {
              '& .MuiButtonBase-root': {
                pointerEvents: 'none',
              },
            },
            '&:hover': {
              '& .MuiButtonBase-root': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.text.opposite,
              },
            },
          };
        }
        return {};
      },
    },
  },
};
